import React from 'react'
import { push, navigateTo } from "gatsby-link"
import styled, { css } from 'styled-components'
import Link from 'gatsby-link'
import { VelocityComponent } from 'velocity-react'
import { Contact } from '../'
import Lottie from 'react-lottie';

if (typeof window !== 'undefined') {
	require('velocity-animate') 
	require('velocity-animate/velocity.ui') 
}

import close from '../../assets/icons/hamburger-close.svg'
import * as mamboOnline from '../../animation/MAMBO_GLOBE_Menu_White.json'

import { media, width } from '../../styles/utils'
import { container, bgIcon, padding, hoverState } from '../../styles/global'
import { red } from '../../styles/colors';

class Menu extends React.Component {

	state = {
		logoHovering: false
	}

	handleNavigation = (route) => {
		navigateTo(route)
		this.props.toggleMenu()
	}

	toggleAnimation = (active) => {
		this.setState({
			logoHovering: active
		})
	}
	
	renderNav = () => {
		const { open } = this.props;

		const navConfig = [
			{
				label: 'Beach',
				link: '/articles/beach'
			},
			{
				label: 'Art',
				link: '/articles/art'
			},
			{
				label: 'Stuff',
				link: '/articles/stuff'
			},
			{
				label: 'About',
				link: '/about'
			},
			{
				label: 'Contact',
				callback: this.props.toggleContact 
			},
		]

		// Add search to mobile menu

		if (width.phone()) {
			navConfig.push({
				label: 'Search',
				link: '/search'
			})
		}
		
		const navItems = navConfig.map((item, i) => {
			return (
				<VelocityComponent
					runOnMount={true}
					animation={open ? 'transition.expandIn' : 'transition.expandOut'}
					duration={450}
					delay={open ? 200 : 0}
					easing={'easeOutCubic'}
					key={i}
				>
					<NavItem
						onClick={item.callback ? item.callback : () => this.handleNavigation(item.link)}
						activeStyle={{
							color: red
						}}
					>
						{item.label}
					</NavItem>
				</VelocityComponent>
			)
		})

		return (
			<Nav>
				{navItems}
			</Nav>
		)
	}
	
	render() {
		const { open, toggleMenu, contactOpen } = this.props;

		return (
			<Wrapper
				open={open}
			>
				<Container>
					<MamboOnline
						href="https://www.bigw.com.au/search/?text=mambo&category="
						target="_blank"
						onMouseEnter={() => this.toggleAnimation(true)}
						onMouseLeave={() => this.toggleAnimation(false)}
					>
						<Lottie
							options={{
								animationData: mamboOnline,
								autoplay: false,
							}}
							width={'100%'}
							height={'100%'}
							isStopped={!this.state.logoHovering}
						/>
					</MamboOnline>

					{this.renderNav()}
					
					<Close
						onClick={toggleMenu}
					/>
				</Container>	

				
				{/* Contact */}

				<Contact
					open={contactOpen}	
					menuOpen={open}	
					toggleMenu={toggleMenu}
					toggleContact={this.props.toggleContact}
					data={this.props.contactData}
				/>				
			</Wrapper>
		)
	}
}


const Wrapper = styled.div`
	background: black;
	height: 100vh;
	width: 100vw;

	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 11;

	pointer-events: none;
	opacity: 0;
	transition: opacity 650ms ease;

	display: flex;
	justify-content: center;

	will-change: opacity;
	transform: translate3d(0,0,0);

	${props => {
		if (props.open) return css`
			opacity: 1;
			pointer-events: all;
		`
	}}
`

const Container = styled.div`
	${container}
	${padding}
	max-width: 1440px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: relative;
	padding: 35px;

	${media.phone`
		padding: 15px 35px 35px;
	`}
`

const MamboOnline = styled.a`
	height: 90px;
	width: 110px;
	z-index: 2;

	position: absolute;
	top: 35px;

	${media.phone`
		top: 15px;
		height: 70px;
		width: 87px;
	`}
`

// Nav

const Nav = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex: 1;
`

const NavItem = styled.div`
	font-family: 'GT America Expanded Bold';
	font-size: 35px;
	color: white;
	line-height: 35px;
	text-transform: uppercase;
	transition: color 0.15s ease;
	cursor: pointer;
	will-change: transform;

	&:not(:last-child) {
		margin-bottom: 40px;
	}

	&:hover {
		color: ${red};
	}

	${media.phone`
		font-size: 25px;

		&:not(:last-child) {
			margin-bottom: 29px;
		}
	`}
`

// Close

const Close = styled.div`
	position: absolute;
	right: 52px;
	top: 60px;
	background-image: url(${close});
	height: 20px;
	width: 20px;
	${bgIcon}
	${hoverState}

	${media.phone`
		position: absolute;
		bottom: 35px;
		top: auto;
		right: 50%;
		transform: translateX(50%);
	`}
`	

export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu/menu.js